import { Box, Center } from '@mantine/core';

import { AuthHeader } from '@/components/layout';
import { ChangePasswordForm } from '@/features/auth/components/ChangePasswordForm';

export const ChangePasswordPage = () => {
  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader />
      <Center px={{ base: 16, md: 24 }} py={{ base: 32, md: 80 }}>
        <ChangePasswordForm />
      </Center>
    </Box>
  );
};
